module.exports = __webpack_public_path__ + "img/Menu-10.d485e5a6.webp";